import { formatPrice } from '../../../../helpers/priceFormatHelper';

export function sum(sumString: string | number | undefined) {
    if (!sumString) {
        return '0';
    }
    sumString = sumString.toString();
    return formatPrice(sumString);
}
